import { GridPaginationModel } from "@mui/x-data-grid";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { CustomDataGrid } from "src/Shared/Components";
import { useModal, useStore, useUpdateEffect } from "src/Shared/Hooks";
import { IPageRequest } from "src/Shared/Interfaces";
import { ISlaReporting } from "../../Interfaces/ISlaReporting";
import { slaReportingColumns } from "./SlaReporting.column";
import { ICompaniesSLAFilterRequest } from "../../Interfaces/ICompaniesSLAFilterRequest";
import CompanySLAInfo from "../CompanySLAInfo/CompanySLAInfo";
import ViewSLAActions from "../ViewSLAActions/ViewSLAActions";
import CompanyOverviewBox from "../CompanyOverviewBox/CompanyOverviewBox";
import ModalContent from "src/Shared/Components/ModalContent/ModalContent";

const SlaReporting: React.FC = () => {
    const {
        rootStore: {
            slaReportingStore: {
                gridLoading,
                getSlaReporting,
                slaReprotingList,
                setSlaReportingList,
                setPagination,
                pagination,
            },
            companyStore: { getCompanyOverview, resetcompanyOverview },
        },
    } = useStore();

    const modal = useModal();

    const [request, setRequest] = useState<IPageRequest<ICompaniesSLAFilterRequest>>({
        pageNumber: pagination.page + 1,
        pageSize: pagination.pageSize,
        filterCollection: {
            year: new Date().getFullYear()
        },
        sortCollection: [],
    });

    const onGridPaginationChange = (data: GridPaginationModel) => {
        setPagination(data);
    };

    useUpdateEffect(() => {
        setRequest({
            filterCollection: { year: new Date().getFullYear() },
            sortCollection: [],
            pageNumber: pagination.page + 1,
            pageSize: pagination.pageSize,
        });
    }, [pagination]);

    useEffect(() => {
        getSlaReporting(request);
    }, [request]);

    const editSlaReporting = (reporting: ISlaReporting) => {
        modal.open(
            <CompanySLAInfo
                primaryCompanyRelationshipManager={reporting.primaryCompanyRelationshipManager}
                companyRowID={reporting.companyRowID}
            />
        );
    };
    const viewActions = (reporting: ISlaReporting) => {
        modal.open(<ViewSLAActions companyRowID={reporting.companyRowID} />);
    };

    const viewCompanyOverview = (companyRowID: string) => {
        resetcompanyOverview();
        getCompanyOverview(companyRowID);
        modal.open(
            <ModalContent
                title="Company Overview"
                maxWidth="lg"
                fullWidth
                buttonText="Close"
                onSaveButtonClick={() => {
                    modal.close();
                }}
            >
                <CompanyOverviewBox />
            </ModalContent>
        );
    };

    return (
        <>
            <CustomDataGrid
                loading={gridLoading}
                rows={slaReprotingList.results || []}
                columns={slaReportingColumns(editSlaReporting, viewActions, viewCompanyOverview)}
                rowCount={slaReprotingList.totalNumberOfRecords || 0}
                getRowId={(row: ISlaReporting) => row.companyID}
                style={{
                    height: "calc(100vh - 140px)",
                }}
                paginationModel={pagination}
                onPaginationModelChange={(model, _) => onGridPaginationChange(model)}
            />
        </>
    );
};

export default observer(SlaReporting);
